import { Outlet } from 'react-router-dom'
import { MobileNav } from '@widgets/mobile-nav'

export const MobileLayout = () => {
  return (
    <div className="relative h-screen overflow-hidden bg-[#1b1c1d]">
      <div className="h-[calc(100vh-92px)] overflow-hidden">
        <Outlet />
      </div>
      <MobileNav />
    </div>
  )
}
